// MainPage.js
import React from 'react';
import './main_page.css'; // Add custom styles for the main content
import { useTranslation } from 'react-i18next';

const MainPage = () => {
    const { t, i18n } = useTranslation('main_page');

    return (
        <main className="main-content">
            {/* Main Section  svg - https://yqnn.github.io/svg-path-editor/*/}
            <section className="main">
                <div className="main__image">
                    <img src={`${process.env.PUBLIC_URL}/images/Imagen-3-scaled.jpg`} alt="logo" />

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 50" fill="#fff">
                        <path d="M0 50V0h1000v2L0 50z"></path>
                        <path d="M0 50V0h1000v12L0 50z" opacity=".5"></path>
                        <path d="M0 50V0h1000v22L0 50z" opacity=".4"></path>
                    </svg>


                </div>

                <div className="main__text">{t('main_text')}</div>
                {/*<div className="main__separator"></div>*/}
            </section>


            { /* Horarios */}
            {/*<section className="horarios">
                <span className="horarios__tittle">{ t('horarios')}</span>

                <div className="horarios__main">
                    <div className="horarios__main__text">
                        <span className="horarios__main__text__sub" >{t('horarios__maintext_1')}</span>
                        <span className="horarios__main__text__hour" >{t('horarios__subtext_1')}</span>
                        <span className="horarios__main__text__hour" >{t('horarios__subtext_2')}</span>
                        <span className="horarios__main__text__sub" >{t('horarios__maintext_2')}</span>
                        <span className="horarios__main__text__hour" >{t('horarios__subtext_3')}</span>
                    </div>

                    <div className="horarios__main__images">
                        <img src={`${process.env.PUBLIC_URL}/images/telefono.png`} alt=""></img>
                        <img src={`${process.env.PUBLIC_URL}/images/ubicacion.png`} alt=""></img>
                    </div>
                </div>
                
            </section>*/}
        </main>
    );
};

export default MainPage;
